import FloorPlanDetail from '../components/FloorPlanDetail';

export default function FloorPlan41Page() {
  const floorPlanData = {
    id: '4-1',
    title: '4+1 Geniş Aile Dairesi',
    totalArea: '165 m²',
    rooms: '4 Yatak Odası + 1 Salon',
    image: '/plan-4-1.png',
    description: '4+1 daire tipimiz, kalabalık aileler için maksimum konfor ve mahremiyet sunmak üzere tasarlanmıştır. Geniş salonu, ebeveyn süiti, misafir yatak odaları ve çalışma odası olmaya uygun alanları ile yaşam kalitenizi zirveye taşır. Üç ayrı banyo ve geniş balkonları ile konforu her köşede hissedeceksiniz.',
    roomDetails: [
      { name: 'Salon', dimensions: '6.20 x 7.50 m', area: '46.50 m²' },
      { name: 'Mutfak', dimensions: '3.80 x 4.50 m', area: '17.10 m²' },
      { name: 'Ana Yatak Odası (Süit)', dimensions: '4.50 x 5.20 m', area: '23.40 m²' },
      { name: 'Yatak Odası 1', dimensions: '3.60 x 4.20 m', area: '15.12 m²' },
      { name: 'Yatak Odası 2', dimensions: '3.40 x 4.00 m', area: '13.60 m²' },
      { name: 'Yatak Odası 3 / Çalışma Odası', dimensions: '3.20 x 3.80 m', area: '12.16 m²' },
      { name: 'Genel Banyo', dimensions: '2.60 x 3.20 m', area: '8.32 m²' },
      { name: 'Ebeveyn Banyosu', dimensions: '2.20 x 2.80 m', area: '6.16 m²' },
      { name: 'Misafir Banyosu', dimensions: '1.80 x 2.40 m', area: '4.32 m²' },
      { name: 'Balkon 1', dimensions: '1.60 x 6.50 m', area: '10.40 m²' },
      { name: 'Balkon 2', dimensions: '1.40 x 4.20 m', area: '5.88 m²' },
      { name: 'Koridor & Hol', dimensions: '-', area: '22.04 m²' }
    ],
    features: [
      'Maksimum genişlik ve ferahlık',
      'Üç ayrı lüks banyo',
      'Özel ebeveyn süiti',
      'Her odada klima altyapısı',
      'Geniş çift balkon kullanımı',
      'Yüksek kaliteli malzeme seçimi',
      'Merkezi ısıtma ve yerden ısıtma',
      'Akıllı ev kontrol paneli',
      'Ses ve ısı yalıtımı',
      'Ankastre mutfak seti'
    ]
  };

  return <FloorPlanDetail data={floorPlanData} />;
}
